import { useState } from 'react';

/**
 * Hook para gestionar el estado del modal de historial de notificaciones
 *
 * Responsabilidades:
 * - Controlar apertura/cierre del modal
 * - Proporcionar estado y funciones de control
 *
 * Patrón: Similar a useUserModals
 */
export const useNotificationsModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return {
    isOpen,
    openModal,
    closeModal,
  };
};
